import { Bar, BarChart, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts'
import { colors } from '@/lib/colors'
import { compactNumber } from '@/lib/format'
import styles from './charts.module.css'

export interface BarDatum {
  name: string
  success: number
  errors: number
  requests: number
}

interface StackedBarsProps {
  data: BarDatum[]
  onClick?: () => void
}

/** Success and error share per site, stacked to 100%, in request-volume order. */
export function StackedBars({ data, onClick }: StackedBarsProps) {
  return (
    <div className={styles.fill} onClick={onClick} style={{ cursor: onClick ? 'pointer' : undefined }}>
      <ResponsiveContainer width="100%" height="100%">
        <BarChart data={data} margin={{ top: 4, right: 4, left: 12, bottom: 8 }} barCategoryGap="18%">
          <XAxis dataKey="name" tick={{ fontSize: 10 }} interval={0} angle={-35} textAnchor="end" height={54} tickFormatter={(v: string) => v.replace(/^www\./, '')} />
          <YAxis hide domain={[0, 100]} />
          <Tooltip
            cursor={{ fill: 'rgba(0,0,0,0.04)' }}
            content={({ active, payload }) => {
              const datum = payload?.[0]?.payload as BarDatum | undefined
              if (!active || !datum) return null
              return (
                <div className={styles.tooltip}>
                  <strong>{datum.name}</strong>
                  Requests: {compactNumber(datum.requests)}
                  <br />
                  Success: {datum.success.toFixed(1)}%
                  <br />
                  Errors: {datum.errors.toFixed(1)}%
                </div>
              )
            }}
          />
          <Bar dataKey="success" stackId="a" fill={colors.ok} isAnimationActive={false} />
          <Bar dataKey="errors" stackId="a" fill={colors.danger} isAnimationActive={false} radius={[3, 3, 0, 0]} />
        </BarChart>
      </ResponsiveContainer>
    </div>
  )
}
